import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ColDef, GridApi } from 'ag-grid-community';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { logisticaModulo as diccionarios } from '../../logistica-diccionario';
import { LogisticaService } from '../../service/logistica.services';
import { IParametroLogistica } from '../../model/parametro-logistica.model';
import { ClaveValorModel } from 'src/app/model/datos-maestros/claveValorModel';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';
import { AsignacionCentroAlmacenService } from 'src/app/aplicaciones-modulos/traslado-logist/service/asignacion-centro-almacen.service';

@Component({
  selector: 'app-configuracion-general',
  templateUrl: './configuracion-general.component.html',
  styleUrls: ['./configuracion-general.component.css']
})
export class ConfiguracionGeneralComponent implements OnInit {
  private readonly CENTROS_DESTINOS_PARENT_DESC = 'TRACK_GENRL_CENTRO_DESTINO';
  private readonly USUARIO_SOBREPESO_PARENT_CODE = 'TRACK_GENRL_USUARIO_SOBREPESO';

  public DAT_TITULOS = diccionarios.titulos.configuracion_general;
  public GLOBAL_TITULOS = diccionarios.titulos.global;
  public DAT_AG_GRID = diccionarios.agGrid;

  public titleModal: string;
  public titleModalCentro: string;
  public titleModalUsuario: string;
  public loading: boolean = false;
  public isCreate: boolean = true;
  public isCreateCentro: boolean = true;
  public isCreateUsuario: boolean = true;

  // Variables para el Grid
  public frameworkComponents: any;
  public columnDefs: ColDef[] = [];
  public defaultColDef: ColDef;
  public gridApi: GridApi;
  public rowData: IParametroLogistica[] = [];
  public textoBuscar: string;

  // Variables funcionales
  public listParents: IParametroLogistica[] = [];
  public parentSelectedId: number;
  public isCentrosDestinosParent: boolean = false;
  public isUsuariosSobrepesoParent: boolean = false;
  public listCentrosDestinos: any[] = [];
  public centroSelectedId: any = null;
  private editingCentroParametroId: number = null;
  public empleadosActivos$: Observable<any[]> = of([]);
  public usuarioSelectedItem: any = null;
  public usuarioSelectedCodigo: string = null;
  public usuarioSelectedNombre: string = null;
  private editingUsuarioParametroId: number = null;
  private usuarioPreloadedItem: any = null;
  public cmbxEstados: ClaveValorModel[] = [
    { clave: 'A', valor: 'ACTIVO' },
    { clave: 'I', valor: 'INACTIVO' }
  ];
  public cmbxTipoParametro: ClaveValorModel[] = [
    { clave: 'V', valor: 'TEXTO' },
    { clave: 'N', valor: 'NUMERO' },
    { clave: 'D', valor: 'FECHA' }
  ];

  public usuarioActual: any;
  public formulario: FormGroup;

  constructor(
    private fb: FormBuilder,
    private logisticaService: LogisticaService,
    private utilServices: UtilsService,
    private dmaestrosAPI: DatosMaestrosService,
    private asignacionCentroAlmacenService: AsignacionCentroAlmacenService
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.usuarioActual = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    this.cargarGridConfig();
    this.loadParents();
  }

  initForm() {
    this.formulario = this.fb.group({
      idParametro: [0],
      nombreParametro: ['', [Validators.required]],
      descripcionParametro: ['', [Validators.required]],
      valorParametroStr: [null],
      valorParametroNum: [null],
      tipoParametro: ['V', [Validators.required]],
      parametroPadre: [null],
      orden: [0],
      estado: ['A', [Validators.required]],
      parametrosHijos: [[]]
    });
  }

  cargarGridConfig() {
    this.frameworkComponents = { buttonRenderer: LfsaBotonEditarGridComponent };
    this.columnDefs = [
      { field: 'idParametro', headerName: 'ID', width: 80, sort: 'desc' },
      { field: 'nombreParametro', headerName: 'Nombre/Código', width: 150 },
      { field: 'descripcionParametro', headerName: 'Descripción', width: 250 },
      { field: 'valorParametroStr', headerName: 'Valor String', width: 150 },
      { field: 'valorParametroNum', headerName: 'Valor Num', width: 100 },
      //{ field: 'tipoParametro', headerName: 'Tipo', width: 80 },
      //{ field: 'orden', headerName: 'Orden', width: 80 },
      { field: 'estado', headerName: 'Estado', width: 100, 
        cellStyle: params => params.value === 'A' ? { color: 'green', fontWeight: 'bold' } : { color: 'red' } 
      },
      { 
        headerName: 'Acciones',
        cellRenderer: 'buttonRenderer', 
        pinned: 'left',
        cellRendererParams: { onClick: this.editar.bind(this), label: 'Editar' },
        width: 100
      },
      { 
        headerName: 'Eliminar',
        cellRenderer: 'buttonRenderer', 
        pinned: 'left',
        cellRendererParams: { onClick: this.delete.bind(this), label: 'Eliminar' },
        width: 100
      }
    ];

    this.defaultColDef = {
      sortable: true,
      filter: true,
      resizable: true,
    };
  }

  loadParents() {
    this.loading = true;
    this.logisticaService.getParametrosLogistica("TRACK_GENRL").subscribe(
      (res: IParametroLogistica[]) => {
        this.loading = false;
        // Filtramos solo los que son padres (parametroPadre null) y tienen hijos o son marcados como padres
        this.listParents = res.filter(p => p.parametroPadre === null);
        if (this.parentSelectedId) {
          this.onParentChange(this.parentSelectedId);
        }
      },
      (err) => {
        this.loading = false;
        console.error('Error cargando parámetros padres', err);
        this.utilServices.mensajeErroToast('Error al cargar parámetros padres');
      }
    );
  }

  onParentChange(event: any) {
    const selectedId = (event && typeof event === 'object' && event.idParametro != null) ? event.idParametro : event;
    this.parentSelectedId = selectedId;

    const parent = this.listParents.find(p => p.idParametro === selectedId);
    this.rowData = parent ? (parent.parametrosHijos || []) : [];
    this.isCentrosDestinosParent = this.isCentrosDestinosSelectedParent();
    this.isUsuariosSobrepesoParent = this.isUsuariosSobrepesoSelectedParent();
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }

  openCentroModal() {
    document.getElementById('abrirModalCentro').click();
  }

  closeCentroModal() {
    document.getElementById('cerrarModalCentro').click();
  }

  nuevo() {
    if (!this.parentSelectedId) {
      this.utilServices.mensajeErroToast('Debe seleccionar un parámetro padre primero');
      return;
    }
    if (this.isCentrosDestinosParent) {
      this.nuevoCentroDestino();
      return;
    }
    if (this.isUsuariosSobrepesoParent) {
      this.nuevoUsuarioSobrepeso();
      return;
    }
    this.isCreate = true;
    this.titleModal = this.GLOBAL_TITULOS.tituloAgregar;
    this.formulario.reset({
      idParametro: 0,
      tipoParametro: 'V',
      parametroPadre: this.parentSelectedId,
      estado: 'A',
      orden: (this.rowData.length + 1),
      parametrosHijos: []
    });
    this.openModal();
  }

  editar({ rowData }) {
    if (this.isCentrosDestinosParent) {
      this.editarCentroDestino(rowData);
      return;
    }
    if (this.isUsuariosSobrepesoParent) {
      this.editarUsuarioSobrepeso(rowData);
      return;
    }
    this.isCreate = false;
    this.titleModal = this.GLOBAL_TITULOS.tituloActualizar;
    this.formulario.reset();
    this.formulario.patchValue(rowData);
    this.openModal();
  }

  delete({ rowData }) {
    const params = {
      title: '¿Está seguro?',
      text: `Desea eliminar el parámetro: ${rowData.descripcionParametro}`,
      action: 'Eliminar'
    };

    this.utilServices.confirmar(params, (confirm) => {
      if (confirm) {
        this.loading = true;
        this.logisticaService.deleteParametroLogistica(rowData.idParametro).subscribe(
          () => {
            this.loading = false;
            this.utilServices.mensajeOKToast('Parámetro eliminado correctamente');
            this.refreshCurrentParent();
          },
          (err) => {
            this.loading = false;
            console.error('Error al eliminar parámetro', err);
            this.utilServices.mensajeErroToast('Error al eliminar parámetro');
          }
        );
      }
    });
  }

  saveForm() {
    if (this.formulario.invalid) return;

    this.loading = true;
    let stringConvoy = this.formulario.get('valorParametroStr').value;
    this.formulario.get('valorParametroStr').setValue(this.formulario.get('nombreParametro').value);
    const raw = this.formulario.getRawValue();
    const idParametro = raw.idParametro;
    const payload = { ...raw };
    delete payload.idParametro;

    //Guardar string en formulario. Solo para Tipos de Convoys. Feat T.42031
    const padre = this.listParents.find(e=> e.idParametro == payload.parametroPadre);
    if (padre.nombreParametro == "TRACK_GENRL_CONVOY") {
      payload.valorParametroStr = stringConvoy?.trim().replaceAll(",", ";");
    };
    //end. Feat T.42031 Mod Logistica, corrige convoy 

    if (this.isCreate) {
      this.logisticaService.createParametroLogistica(payload).subscribe(
        () => {
          this.loading = false;
          this.utilServices.mensajeOKToast('Parámetro creado correctamente');
          this.closeModal();
          this.refreshCurrentParent();
        },
        (err) => {
          this.loading = false;
          console.error('Error al crear parámetro', err);
          this.utilServices.mensajeErroToast('Error al crear parámetro');
        }
      );
    } else {
      this.logisticaService.updateParametroLogistica(idParametro, payload).subscribe(
        () => {
          this.loading = false;
          this.utilServices.mensajeOKToast('Parámetro actualizado correctamente');
          this.closeModal();
          this.refreshCurrentParent();
        },
        (err) => {
          this.loading = false;
          console.error('Error al actualizar parámetro', err);
          this.utilServices.mensajeErroToast('Error al actualizar parámetro');
        }
      );
    }
  }

  refreshCurrentParent() {
    // Recargamos todos para actualizar la estructura
    this.logisticaService.getParametrosLogistica("TRACK_GENRL").subscribe(
      (res: IParametroLogistica[]) => {
        this.listParents = res.filter(p => p.parametroPadre === null);
        if (this.parentSelectedId) {
          const updatedParent = this.listParents.find(p => p.idParametro === this.parentSelectedId);
          this.rowData = updatedParent ? (updatedParent.parametrosHijos || []) : [];
          this.isCentrosDestinosParent = this.isCentrosDestinosSelectedParent();
        }
      }
    );
  }

  private isCentrosDestinosSelectedParent(): boolean {
    const parent = this.listParents.find(p => p.idParametro === this.parentSelectedId);
    const desc = String(parent?.nombreParametro ?? '').trim().toUpperCase();
    return desc === this.CENTROS_DESTINOS_PARENT_DESC;
  }

  private isUsuariosSobrepesoSelectedParent(): boolean {
    const parent = this.listParents.find(p => p.idParametro === this.parentSelectedId);
    const code = String(parent?.nombreParametro ?? '').trim().toUpperCase();
    return code === this.USUARIO_SOBREPESO_PARENT_CODE;
  }

  private ensureCentrosDestinosLoaded() {
    if (Array.isArray(this.listCentrosDestinos) && this.listCentrosDestinos.length > 0) return;
    this.dmaestrosAPI.getAllCentroLogistico().subscribe((res: any[]) => {
      const lista = Array.isArray(res) ? res : [];
      this.listCentrosDestinos = lista.map((e: any) => ({
        ...e,
        descripcion: `${e.idCentro} - ${e.nombreCentro}`
      }));
    }, (err) => {
      console.error('Error cargando centros logísticos', err);
      this.listCentrosDestinos = [];
      this.utilServices.mensajeErroToast('Error al cargar centros logísticos');
    });
  }

  private getNextOrdenForChild(): number {
    if (!Array.isArray(this.rowData) || this.rowData.length === 0) return 1;
    const maxOrden = this.rowData
      .map(e => Number((e as any)?.orden ?? 0))
      .filter(n => !Number.isNaN(n))
      .reduce((a, b) => Math.max(a, b), 0);
    return maxOrden + 1;
  }

  private existeCodigoEnGrid(codigo: any, excludeIdParametro: number = null): boolean {
    const code = String(codigo ?? '').trim();
    if (!code) return false;
    return (this.rowData || []).some((e: any) => {
      const current = String(e?.nombreParametro ?? '').trim();
      if (excludeIdParametro != null && Number(e?.idParametro) === Number(excludeIdParametro)) return false;
      return current === code;
    });
  }

  private nuevoCentroDestino() {
    this.isCreateCentro = true;
    this.editingCentroParametroId = null;
    this.titleModalCentro = this.GLOBAL_TITULOS.tituloAgregar;
    this.centroSelectedId = null;
    this.ensureCentrosDestinosLoaded();
    this.openCentroModal();
  }

  private editarCentroDestino(rowData: any) {
    this.isCreateCentro = false;
    this.editingCentroParametroId = Number(rowData?.idParametro ?? null);
    this.titleModalCentro = this.GLOBAL_TITULOS.tituloActualizar;
    this.ensureCentrosDestinosLoaded();
    const currentCodigo = rowData?.nombreParametro ?? rowData?.valorParametroStr ?? null;
    this.centroSelectedId = currentCodigo != null ? String(currentCodigo).trim() : null;
    this.openCentroModal();
  }

  saveCentroParametro() {
    const codigo = this.centroSelectedId != null ? String(this.centroSelectedId).trim() : '';
    if (!codigo) {
      this.utilServices.mensajeErroToast('Debe seleccionar un centro');
      return;
    }

    if (this.existeCodigoEnGrid(codigo, this.isCreateCentro ? null : this.editingCentroParametroId)) {
      this.utilServices.mensajeErroToast('El centro seleccionado ya existe en la grilla');
      return;
    }

    const centro = (this.listCentrosDestinos || []).find((c: any) => String(c?.idCentro ?? '').trim() === codigo);
    if (!centro) {
      this.utilServices.mensajeErroToast('Centro no válido');
      return;
    }

    const currentRow = this.isCreateCentro
      ? null
      : (this.rowData || []).find((e: any) => Number(e?.idParametro) === Number(this.editingCentroParametroId));

    const payload: any = {
      nombreParametro: codigo,
      descripcionParametro: centro.descripcion ?? centro.nombreCentro,
      valorParametroStr: codigo,
      valorParametroNum: null,
      tipoParametro: currentRow?.tipoParametro ?? 'V',
      parametroPadre: this.parentSelectedId,
      orden: this.isCreateCentro ? this.getNextOrdenForChild() : (currentRow?.orden ?? 0),
      estado: currentRow?.estado ?? 'A',
      parametrosHijos: []
    };

    this.loading = true;
    if (this.isCreateCentro) {
      this.logisticaService.createParametroLogistica(payload).subscribe(
        () => {
          this.loading = false;
          this.utilServices.mensajeOKToast('Parámetro creado correctamente');
          this.closeCentroModal();
          this.refreshCurrentParent();
        },
        (err) => {
          this.loading = false;
          console.error('Error al crear parámetro', err);
          this.utilServices.mensajeErroToast('Error al crear parámetro');
        }
      );
      return;
    }

    this.logisticaService.updateParametroLogistica(this.editingCentroParametroId, payload).subscribe(
      () => {
        this.loading = false;
        this.utilServices.mensajeOKToast('Parámetro actualizado correctamente');
        this.closeCentroModal();
        this.refreshCurrentParent();
      },
      (err) => {
        this.loading = false;
        console.error('Error al actualizar parámetro', err);
        this.utilServices.mensajeErroToast('Error al actualizar parámetro');
      }
    );
  }

  openUsuarioModal() {
    document.getElementById('abrirModalUsuario').click();
  }

  closeUsuarioModal() {
    document.getElementById('cerrarModalUsuario').click();
  }

  private loadEmpleadosActivos(filtro: string = 'A') {
    this.empleadosActivos$ = this.asignacionCentroAlmacenService.searchEmpleadosActive({ filtro }).pipe(
      map((res: any) => {
        const list = Array.isArray(res?.respuesta) ? res.respuesta : [];
        if (this.usuarioPreloadedItem && !list.some((e: any) => String(e?.codigo ?? '').trim() === String(this.usuarioPreloadedItem?.codigo ?? '').trim())) {
          return [this.usuarioPreloadedItem, ...list];
        }
        return list;
      }),
      catchError(() => of(this.usuarioPreloadedItem ? [this.usuarioPreloadedItem] : []))
    );
  }

  private nuevoUsuarioSobrepeso() {
    this.isCreateUsuario = true;
    this.editingUsuarioParametroId = null;
    this.titleModalUsuario = this.GLOBAL_TITULOS.tituloAgregar;
    this.usuarioSelectedItem = null;
    this.usuarioSelectedCodigo = null;
    this.usuarioSelectedNombre = null;
    this.usuarioPreloadedItem = null;
    this.loadEmpleadosActivos('A');
    this.openUsuarioModal();
  }

  private editarUsuarioSobrepeso(rowData: any) {
    this.isCreateUsuario = false;
    this.editingUsuarioParametroId = Number(rowData?.idParametro ?? null);
    this.titleModalUsuario = this.GLOBAL_TITULOS.tituloActualizar;
    this.usuarioSelectedCodigo = rowData?.nombreParametro != null ? String(rowData.nombreParametro).trim() : null;
    this.usuarioSelectedNombre = rowData?.descripcionParametro != null ? String(rowData.descripcionParametro).trim() : null;
    this.usuarioPreloadedItem = (this.usuarioSelectedCodigo || this.usuarioSelectedNombre)
      ? { codigo: this.usuarioSelectedCodigo, nombres: this.usuarioSelectedNombre }
      : null;
    this.usuarioSelectedItem = this.usuarioPreloadedItem;
    this.loadEmpleadosActivos('A');
    this.openUsuarioModal();
  }

  onUsuarioSelected(event: any) {
    this.usuarioSelectedItem = event ?? null;
    this.usuarioSelectedCodigo = event?.codigo != null ? String(event.codigo).trim() : null;
    this.usuarioSelectedNombre = event?.nombres != null ? String(event.nombres).trim() : null;
  }

  saveUsuarioParametro() {
    const codigo =
      (this.usuarioSelectedItem?.codigo != null ? String(this.usuarioSelectedItem.codigo).trim() : '') ||
      (this.usuarioSelectedCodigo != null ? String(this.usuarioSelectedCodigo).trim() : '');
    const nombres =
      (this.usuarioSelectedItem?.nombres != null ? String(this.usuarioSelectedItem.nombres).trim() : '') ||
      (this.usuarioSelectedNombre != null ? String(this.usuarioSelectedNombre).trim() : '');

    if (!codigo) {
      this.utilServices.mensajeErroToast('Debe seleccionar un usuario');
      return;
    }

    if (this.existeCodigoEnGrid(codigo, this.isCreateUsuario ? null : this.editingUsuarioParametroId)) {
      this.utilServices.mensajeErroToast('El usuario seleccionado ya existe en la grilla');
      return;
    }

    const currentRow = this.isCreateUsuario
      ? null
      : (this.rowData || []).find((e: any) => Number(e?.idParametro) === Number(this.editingUsuarioParametroId));

    const payload: any = {
      nombreParametro: codigo,
      descripcionParametro: nombres || currentRow?.descripcionParametro || codigo,
      valorParametroStr: codigo,
      valorParametroNum: null,
      tipoParametro: currentRow?.tipoParametro ?? 'V',
      parametroPadre: this.parentSelectedId,
      orden: this.isCreateUsuario ? this.getNextOrdenForChild() : (currentRow?.orden ?? 0),
      estado: currentRow?.estado ?? 'A',
      parametrosHijos: []
    };

    this.loading = true;
    if (this.isCreateUsuario) {
      this.logisticaService.createParametroLogistica(payload).subscribe(
        () => {
          this.loading = false;
          this.utilServices.mensajeOKToast('Parámetro creado correctamente');
          this.closeUsuarioModal();
          this.refreshCurrentParent();
        },
        (err) => {
          this.loading = false;
          console.error('Error al crear parámetro', err);
          this.utilServices.mensajeErroToast('Error al crear parámetro');
        }
      );
      return;
    }

    this.logisticaService.updateParametroLogistica(this.editingUsuarioParametroId, payload).subscribe(
      () => {
        this.loading = false;
        this.utilServices.mensajeOKToast('Parámetro actualizado correctamente');
        this.closeUsuarioModal();
        this.refreshCurrentParent();
      },
      (err) => {
        this.loading = false;
        console.error('Error al actualizar parámetro', err);
        this.utilServices.mensajeErroToast('Error al actualizar parámetro');
      }
    );
  }
}
